import { render } from "./PayPal.vue?vue&type=template&id=e2d35866&scoped=true"
import script from "./PayPal.vue?vue&type=script&lang=js"
export * from "./PayPal.vue?vue&type=script&lang=js"

import "./PayPal.vue?vue&type=style&index=0&id=e2d35866&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e2d35866"

export default script